export const UPLOAD = {
  maxSize: 1000000,
};
